import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";

export function Header(): JSX.Element {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className="Header">
            <span className="headerTitle">
                <NavLink to="/loop"><h1>LoopyDoopy</h1></NavLink>
            </span>
            <span className={`headerLinks ${menuOpen ? 'open' : ''}`}>
                <NavLink to="/home" onClick={toggleMenu}>Loopy</NavLink>
                <NavLink to="/media" onClick={toggleMenu}>Media</NavLink>
                <NavLink to="/about" onClick={toggleMenu}>About</NavLink>
            </span>
            <button className="burgerMenu" onClick={toggleMenu}>
                ☰
            </button>
        </div>
    );
}
